module.exports = __webpack_public_path__ + "static/media/ic_letter.bc71a839.svg";